import styled from "styled-components";

export const Heading = styled.h2`
  color: yellow;
  font-size: 0.8em;
  line-height: 1.3em;
  letter-spacing: 0.03em;
  margin: 0px;
  margin-bottom: 16px;
`;
